export default {
  primary: '#3200E6',
  secondary: '#002878',
};
